import React from "react"
import clsx from "clsx"

interface FooterProps {
  className?: string
  footerText: string
  contactNumber?: string
  contactEmail?: string
  feedbackFormUrl?: string
}

export const LuiFooter: React.FC<FooterProps> = (props) => {
  return (
    <footer className={clsx("g-footer-wrapper g-footer__standard lui-footer", props.className)} role="contentinfo">
      <div className="g-flex-container lui-max-width">
        <div className="g-flex-row">
          <div className="g-flex-col g-flex-col-xs-12 g-flex-col-sm-9 g-flex-col-md-10 g-flex-col-lg-10">
            <div className="g-footer__standard-item">
              <h2>{props.footerText}</h2>
            </div>
          </div>
          <div className="g-flex-col g-flex-col-xs-12 g-flex-col-sm-3 g-flex-col-md-2 lui-row-divider-xs lui-row-divider-sm">
            <h3>Connect</h3>
            <ul className="g-footer__standard-inline-list lui-footer-list">
              {props.contactNumber && (
                <li>
                  <a className="g-footer__standard-link" href={"tel:" + props.contactNumber}>
                    {props.contactNumber}
                  </a>
                </li>
              )}
              {props.contactEmail && (
                <li>
                  <a className="g-footer__standard-link" href={"mailto:" + props.contactEmail}>
                    Email
                  </a>
                </li>
              )}
              {props.feedbackFormUrl && (
                <li>
                  <a
                    className="g-footer__standard-link"
                    href={props.feedbackFormUrl}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Give feedback
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="g-flex-row lui-footer-logo-row lui-row-divider-xs lui-row-divider-sm">
          <div className="g-flex-col g-flex-col-xs-12 g-flex-col-sm-6 lui-footer-linz-logo">
            <a href="https://www.linz.govt.nz" rel="noopener noreferrer" target="_blank">
              <img
                alt="Land Information New Zealand (LINZ) - Toitū te whenua"
                className="jss180"
                src="https://search.landonline.govt.nz/static/media/linz-logo-footer.47b8af63.svg"
              />
            </a>
          </div>
          <div className="g-flex-col g-flex-col-xs-12 g-flex-col-sm-6 lui-footer-nz-govt-logo">
            <a href="https://www.govt.nz" rel="noopener noreferrer" target="_blank">
              <img
                alt="Open New Zealand Government website in new window/tab. "
                className="jss181"
                src="https://search.landonline.govt.nz/static/media/nz-govt-logo-rev.ed9e5ad5.svg"
              />
            </a>
          </div>
        </div>
        <div className="g-flex-row margin-top-md lui-row-divider-xs lui-row-divider-sm lui-row-divider-md lui-row-divider-lg lui-row-divider-xl">
          <div className="g-flex-col g-flex-col-xs-12 g-flex-col-sm-8 g-flex-col-md-9">
            <ul className="g-footer__standard-inline-list">
              <li className="g-footer__standard-inline-list-item">
                <a
                  className="g-footer__standard-link"
                  href="https://www.digital.govt.nz/home/about-digital-govt-nz/contact-us/"
                >
                  Contact
                </a>
              </li>
              <li className="g-footer__standard-inline-list-item">
                <a
                  className="g-footer__standard-link"
                  href="https://www.digital.govt.nz/home/about-digital-govt-nz/privacy/"
                >
                  Privacy
                </a>
              </li>
            </ul>
          </div>
          <div className="g-flex-col g-flex-col-xs-12 g-flex-col-sm-4 g-flex-col-md-3 lui-footer-copyright lui-row-divider-xs">
            <p className="g-footer__standard-small-text">© 2020 Land Information New Zealand</p>
          </div>
        </div>
      </div>
    </footer>
  )
}
